import { Component } from '@angular/core';
import { EnumMeasureTypes } from '@library/store/measures/measures.interface';
import { ModulesFacade } from '@library/store/modules/modules.facade';
import { Module } from '@library/store/modules/modules.interface';
import { ControlPageCardService } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-sidebar/control-page-card.service';
import { SidebarRoomService } from '@pages/control-page/control-page-main/control-page-dashboard/control-page-sidebar/sidebar-rooms/sidebar-room-card/sidebar-room.service';
import { ControlPageStore, GraphType } from '@pages/control-page/control-page-store.service';
import { RAIN_MODULES } from '@pages/control-page/control-page.const';
import { combineLatest, map } from 'rxjs';

@Component({
  selector: 'app-room-rain',
  templateUrl: './room-rain.component.html',
  styleUrls: ['./room-rain.component.scss']
})
export class RoomRainComponent {

  display$ = this.sidebarRoomService.roomModules$.pipe(
    map((modules) => {
      return modules.map(m => m.type).some(type => RAIN_MODULES.includes(type));
    }),
  );

  private module$ = this.sidebarRoomService.roomModules$.pipe(
    map(modules => {
      return modules.find(m => RAIN_MODULES.includes(m.type));
    })
  );

  viewModel$ = combineLatest({
    module: this.module$,
    modules: this.modulesFacade.modules$,
    room: this.sidebarRoomService.room$,
    card: this.controlPageStore.card$,
  });

  EnumMeasureTypes = EnumMeasureTypes;
  GraphType = GraphType;

  constructor(
    public sidebarRoomService: SidebarRoomService,
    private controlPageCardService: ControlPageCardService,
    private controlPageStore: ControlPageStore,
    private modulesFacade: ModulesFacade,
  ) { }

  selectRain(module: Module) {
    this.controlPageCardService.selectRain(module);
  }

}
